// extracted by mini-css-extract-plugin
export var actionButton = "_az-1";
export var actionButtons = "_az-2";
export var actions = "_az-0";
export var aiUnread = "_az-10";
export var alignCenter = "_az-h";
export var backWrapper = "_az-3";
export var cellContainer = "_az-4";
export var checkboxContainer = "_az-5";
export var contentContainer = "_az-6";
export var contentHeader = "_az-8";
export var conversationsTableWrapper = "_az-s";
export var draftReplyBadgeContainer = "_az-m";
export var dropdownItem = "_az-b";
export var dropdownItemsContainer = "_az-a";
export var dropdownTitle = "_az-c";
export var errorIcon = "_az-7";
export var filter = "_az-d";
export var gray = "_az-i";
export var headerActionButtons = "_az-e";
export var headerCheckboxContainer = "_az-f";
export var icon = "_az-j";
export var menuContainer = "_az-k";
export var noMoreTicketsIcon = "_az-12";
export var noMoreTicketsSubText = "_az-13";
export var oneLine = "_az-l";
export var optionsButton = "_az-n";
export var plus = "_az-o";
export var portalButtonsWrapper = "_az-g";
export var red = "_az-p";
export var scrolledTop = "_az-9";
export var search = "_az-q";
export var selectedConversationsCount = "_az-r";
export var spinner = "_az-t";
export var strong = "_az-u";
export var summaryCell = "_az-v";
export var tableContainer = "_az-11";
export var tagContainer = "_az-w";
export var threeDots = "_az-x";
export var twoLines = "_az-y";
export var unread = "_az-z";